<template lang="pug">
  div
    top-two
    router-view
</template>

<script>
  import TopTwo from '@/views/Top/TopTwo'

  export default {
    name: 'base',
    components: {
      TopTwo,
    }
  }
</script>
